import config from "@Config/index";

export const SHOW_NEW_HEADER = true;
export const SHOW_NEW_FOOTER = true;
export const SHOW_NEW_BOTTOM_NAVBAR = true;
export const FACEBOOK_URL = "https://www.facebook.com/amberstudent";
export const TWITTER_URL = "https://twitter.com/amberstudent_";
export const INSTAGRAM_URL = "https://www.instagram.com/amberstudent/";
export const YOUTUBE_URL = "https://www.youtube.com/channel/UCzm8GT3xWuXqQt9O7CFpqJw";
export const LINKEDIN_URL = "https://www.linkedin.com/company/amberstudent";
export const PINTEREST_URL = "https://www.pinterest.com/amberstudent/";
export const WECHAT_URL = "https://mp.weixin.qq.com/s/OtqDxSQd6nOEWlgLWVv6PA";
// export const LOGO_URL =
//   "https://prod-static-assets.amberstudent.com/images/logo/amber_red_logo_small.png?fm=pjpg&auto=format"
//     ? //export const BASE_IMG_URL = config.global.isChinaApp
//       " https://imgix.amberstudent.cn/images/"
//     : "https://prod-static-assets.amberstudent.com/images/";
export const TRUSTPILOT_REVIEWS_URL = "https://www.trustpilot.com/review/amberstudent.com";
export const HOME_URL = "/";
export const BLOG_URL = "/blog";
export const HELP_URL = "/help";
// export const CAREERS_URL = 'https://amberstudent.freshteam.com/jobs'

export const WECHAT_QR_URL = `${config.IMAGE_STATIC_URL}/images/wechat-qr.png?auto=format&q=10`;
export const XHR_QR_URL = `${config.IMAGE_STATIC_URL}/images/xhr_qr.jpg?auto=format&q=10`;
export const IMAGE_STATIC_PREFIX = "https://prod-static-assets.amberstudent.com/images/";

export const COMPONENTS_CATEGORY = {
  TOP_NAV: "top_nav",
  BOTTOM_NAV: "bottom_nav",
  AERO_BAR: "aero_bar",
};

export const EVENT_LABEL = {
  SUPPORT_CLICKED: "support_clicked",
  QUICK_CHAT_CLICKED: "quick_chat_clicked",
  WHATSAPP_CLICKED: "whatsapp_clicked",
  FACEBOOK_CLICKED: "facebook_clicked",
  WECHAT_CLICKED: "weChat_clicked",
  PHONE_CLICKED: "phone_clicked",
  EMAIL_CLICKED: "email_clicked",
  HELP_CENTRE_CLICKED: "help_centre_clicked",
  HOW_IT_WORKS_CLICKED: "how_it_works_clicked",
  SHORTLIST_CLICKED: "shortlist_clicked",
  LOGIN_CLICKED: "login_clicked",
  LOGOUT_CLICKED: "logout_clicked",
  MENU_CLICKED: "menu_clicked",
  PROFILE_CLICKED: "profile_clicked",
  BOOKINGS_CLICKED: "bookings_clicked",
  REFER_CLICKED: "refer_clicked",
  PARTNER_WITH_US_CLICKED: "partner_with_us_clicked",
  LIST_WITH_US_CLICKED: "list_with_us_clicked",
  EXPLORE_CLICKED: "explore_clicked",
  CHAT_CLICKED: "chat_clicked",
  GROUP_BOOKINGS_CLICKED: "group_bookings_clicked",
  LANGUAGE_MODAL_CLICKED: "language_modal_clicked",
  LANGUAGE_SELECTED: "language_selected",
  LANGAUE_SAVED: "language_saved",
  ACTIVITY_CLICKED: "activity_clicked",
  AEROBAR_CLOSED: "aerobar_closed",
  AEROBAR_OPEN: "aerobar_clicked",
  MAP_VIEW_TOGGLE_CLICKED: "map_view_toggle_clicked",
  HOME_CLICKED: "home_clicked",
  DASHBOARD_CLICKED: "dashboard_clicked",
  AMBER_FLEX_CLICKED: "amber_flex_clicked",
  AMBER_CONNECT_CLICKED: "amber_connect_clicked",
  AMBER_HOUSE_RULES_CLICKED: "house_rules_section",
  CHATBOT_OPENED: "chatbot_opened",
  CHATBOT_CLOSED: "chatbot_closed",
};

export const FLOATING_BUTTON_ENTRY_POINTS = {
  FLOATING_BUTTON: "floating_button",
  PAGE_BUTTON: "page_button",
};
export const APP_LINK = "/api/flag/redirect_to_install_app";
export const CAREERS_URL = "/career";
export const ABOUT_URL = "/about";
export const DASHBOARD_URL = "/dashboard";
export const GROUP_BOOKINGS_URL = "/group-booking";
export const REFER_URL = "/referral-programme";
export const LEADS_URL = "/places/leads";
export const LEADS_LIST = "/list";
export const HOW_IT_WORKS_URL = "/how-it-works";
export const CONTACT_URL = "/contact";
export const NEWSROOM_URL = "/news";
export const AMBASSADOR_URL = "/ambassador";
export const AMBERPLUS_URL = "/plus";
export const SCHOLARSHIP_URL = "/scholarship";
export const EXAMS_URL = "/exams";
export const TERMS_URL = "/terms";
export const PRIVACY_URL = "/privacy";
export const SITEMAP_URL = "/sitemap";
export const MEDIA_MENTION_URL = "/media";
export const PODCAST_URL = "/podcast";
export const PROFILE_URL = "/profile";
export const PROFILE_LEADS_URL = "/profile/leads";
export const PROFILE_PAYMENTS_URL = "/profile/payments";
export const PROFILE_SHORTLIST_URL = "/profile/shortlist";
export const PROFILE_APPLICATIONS_URL = "/profile/applications";
export const PARTNER_WITH_AMBER_URL = "/partner";
export const ADDRESS_US = "40 E Main St #1215 Newark DE, USA";
export const ADDRESS_US_2 = "40 E Main St # 1215 Newark 19711-4639";
export const ADDRESS_INDIA = "91 Springboard, Creaticity, Yerawada, Pune, Maharashtra 411006";
export const REGISTERED_NAME_INDIA = "Amber Healthcare Solutions Pvt Ltd.";
export const REGISTERED_NAME_US = "Amber Internet solutions Inc.";
export const EMAIL_1 = "contact@amberstudent.com";
export const PHONE_1 = {
  country_code: "+44",
  country_code_raw: "44",
  country_code_name: "gb",
  full_number: "+44 7456741634",
  number: "7456741634",
};
export const PHONE_2 = {
  country_code: "+91",
  country_code_raw: "91",
  country_code_name: "in",
  full_number: "+91 8035735724",
  number: "8035735724",
};
export const PHONE_3 = {
  country_code: "+1",
  country_code_raw: "1",
  country_code_name: "us",
  full_number: "+1 9176959425",
  number: "9176959425",
};
export const PHONE_4 = {
  country_code: "+61",
  country_code_raw: "61",
  country_code_name: "au",
  full_number: "+61 868457597",
  number: "868457597",
};
export const PHONE_WHATSAPP_OUTBOUND = {
  country_code: "+44",
  country_code_raw: "44",
  country_code_name: "gb",
  full_number: "+44 7888863490",
  number: "7888863490",
};
export const PAGE = {
  HOME: "home_page",
  SEARCH: "search_page",
  PROFILE: "profile_page",
  INVENTORY: "inventory_page",
  LEADFORMPAGE: "lead_form_page",
  BOOKFORM: "book_form",
  PAYMENTFORM: "payment_form",
  SHORTLIST: "shortlist_page",
  SUPPORT: "support_page",
};
export const PROFILE_DROPDOWN = "Profile_dropdown";
// webflow urls
export const WEBFLOW_DEV = {
  BLOG_URL: "https://amber-blog-cms.webflow.io",
  NEWS_URL: "https://amber-newsroom.webflow.io",
  PLUS_URL: "https://amber-plus.webflow.io",
  MASTER_URL: "https://master-amber.webflow.io",
  PODCAST_URL: "https://amber-podcast.webflow.io",
};

export const WEBFLOW_PROD = {
  BLOG_URL: "https://b.internal.amberstudent.com",
  NEWS_URL: "https://n.internal.amberstudent.com",
  PLUS_URL: "https://plus.internal.amberstudent.com",
  MASTER_URL: "https://pages.internal.amberstudent.com",
  PODCAST_URL: "https://podcast.internal.amberstudent.com",
};
export const FACEBOOK_MESSENGER_URL = "https://m.me/amberstudent";
export const WHATSAPP_URL = `https://wa.me/${PHONE_WHATSAPP_OUTBOUND.country_code_raw}${PHONE_WHATSAPP_OUTBOUND.number}`;
export const WE_CHAT_URL = "https://mp.weixin.qq.com/s/OtqDxSQd6nOEWlgLWVv6PA";
export const WECHAT_CHAT_URL = "https://work.weixin.qq.com/kfid/kfc31efab556f4ae635";

export const SHOW_APP_BANNER_SESSION = "show_app_banner_session";
export const SCROLL_DEBOUNCE_THRESHOLD = 30;
export const A_SHOW_BANNER = "A_SHOW_BANNER";
export const B_NOT_SHOW_BANNER = "B_NOT_SHOW_BANNER";

export const WEBFLOW_CACHE_TIME = 12 * 60 * 60;
export const INVENTORY_CACHE_TIME = 12 * 60 * 60; // 12 hours

export const DEFAULT_FIREBASE_CONFIG_FLAGS = {
  homePageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  searchPageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  propertyPageBanner:
    '{"showBanner":true,"content":"Insider Tip: Save up to £5000! Book your student home early for the 2024 intake risk-free. Grab full refund on Visa or Uni rejection!","link":"","icon":"megaphone","withAnimation":true}',
  chinaNewYearBanner:
    '{"showBanner":true,"content":"【龙年特惠】现在通过amber预订您的海外留学公寓，即可享受888元人民币的现金返还大礼！活动截止日期至2024年2月28日，赶快行动，不容错过！","link":"","icon":"megaphone","withAnimation":true}',
  isEdgeEnabled: "false",
  isProfileV2: "true",
  isHomeV2: "true",
  isAppBannerAvailable: "true",
  lazyLoadTimeout: "0",
  isBookingV2: "true",
  isReleaseV16: "true",
  newPropertyPageCities: "[]",
  isPropertyV2View: "true",
  isNewRoomTypes: "false",
  isFooterV2: "true",
  // isBookFormV2: 'true',
  isNewHome: "true",
  isDialerV2: "false",
  AmberApp: {
    appSentryTraceSampleRate: "0.3",
    appIsNewSearch: "true",
  },
  agentIds: "[]",
  // showPriceTrends: config.priceTrends.isVisible,
  isNewPlusPage: "true",
  enableAutomatedBanners: false,

  referPageStats: { "people-referred": "10,000+", "payout-disbursed": "GBP 500K+" },
  showAppNudge: true,
  showPartnerWithUs: "true",
  showVirtualViewRequest: true,
  showPlusCategoryBannerImage: false,
  isNewLeadFormFlow: true,
  isLangChina: false,
};

export const GROWTH_BOOK_FEATURE_FLAG_NAMES = {
  WITHOUT_ENQUIRE: "pod_discovery_search_page_no_enquire",
  BOOKFORM_HAPPY_FLOW_V2: "pod_transaction_bookform_happy_flow_v2",
  ENABLE_PAYMENT_BEFORE_BF: "pod_transaction_enable_payment_before_bookform",
  ROOM_TYPE_3D: "pod_discovery_room_type_3D",
  ZENDESK_LOGIN_POPUP: "pod_transaction_zendesk_login_popup",
  ZENDESK_ICON_SUCCESS_PAGE_LF1: "pod_transaction_zendesk_icon_lf1_success",
  SHOW_QUERY_FIELD_LF1: "pod_transaction_show_query_field_LF1",
  SHOW_CONNECT_SECTION_PROPERTY_PAGE: "pod_transaction_connect_option_property_page",
  POST_LEAD_SUBMISSION_ZENDESK_FLOW: "pod_transaction_zendesk_flow_post_lead_submission",
  ACCOMMODATION_DETAILS_CARD_V2: "pod_transaction_accommodation_details_card_v2",
  OPEN_LEAD_MODAL_FROM_BOOK_CTA: "pod_transaction_book_cta_open_lead_modal",
  SHOW_AGENT_DETAILS: "pod_discovery_agent_support_detail",
  ENABLE_APPLICATION_FORM_FLOW: "pod_transaction_application_form_flow",
  IS_DOMESTIC_USER: "pod_transaction_is_domestic_user",
  APPLY_FORM_VALIDATIONS: "pod_transaction_apply_form_validations",
  CUSTOM_OTHER_MOVE_IN: "pod_transaction_custom_other_move_in",
  APPLY_NOW_CTA: "pod_transaction_apply_now_cta",
  VIEW_ROOM_PRIMARY_CTA: "pod_transaction_view_room_primary_cta",
  LEAD_FORM_MODAL_INVENTORY_CARD_V2: "pod_transaction_lead_form_modal_inventory_card_v2",
  MOVE_IN_MONTH_POPUP: "pod_discovery_move_in_month_popup",
  GALLERY_SECTION_V2: "gallery_section_v2",
  ENABLE_BOOK_FORM_FOR_INACTIVE_PROPERTY: "pod_transaction_enable_book_form_inactive_property",
  SHOW_SEARCH_PROPERTY_PAGE: "pod_discovery_show_search_property_page",
  BILLS_AND_PAYMENTS: "pod_discovery_bills_and_instalment_plan",
  SLASHED_PRICING: "pod_discovery_slashed_pricing",
  SHOW_BILLS_INCLUDED: "pod_discovery_show_bills_included",
  USER_COMM_PREFERENCE_LEADFORM: "pod_discovery_user_preference_leadform",
  SHOW_LOGIN_CTA_BOOK_PAYMENT_HEADER: "show_login_cta_book_payment_header",
  SEARCH_PROPERTY_PAGE_CTA_EXPERIMENT_VALUE: "pod_discovery_search_property_page_cta_experiment_v2",
  GUARANTOR_INLINE_FILTER: "pod_discovery_guarantor_inline_filter",
  TRNASACTIONAL_FORMS_EXIT_DIALOG_BOX: "pod_discovery_transaction_forms_exit_dialog_enabled",
  SHOW_FILTERS_SHIMMER_ANIMATION: "pod_discovery_show_filters_shimmer_animation",
  SHOW_UCAS_ANNOUNCEMENT_MODAL: "pod_discovery_show_ucas_announcement_modal",
  LEAD_FORM_WITH_STEPPER: "pod_discovery_lead_form_with_stepper",
  SEARCH_PAGE_FILTERS_EXPERIMENT: "pod_discovery_search_filters_experiment",
  SEARCH_TAGS_SCROLLABLE: "pod_discovery_search_tags_scrollable",
  APPLY_FOR_FALL_EXPERIMENT: "pod_discovery_apply_for_fall_experiment",
  SHOW_BOOKFORM_VALIDATION: "pod_discovery_bookform_validation",
  AMBER_COPILOT: "pod_AI_show_copilot_chat_widget",
  ONE_PLATFORM_CURRENCY_CHANGES: "pod_discovery_one_platform_currency_changes",
  POD_APP_LANG_AND_CURRENCY_FEAT: "pod_app_lang_and_currency_feat",
  USER_PREFERENCE_COMMUNICATION: "pod_discovery_user_preference_communication",
  USE_JAVA_API_SEARCH: "pod_eng_use_java_api_search",
  PROPERTIES_NEAR_ME: "pod_discovery_properties_near_me",
  GOT_QUESTIONS_FIELD_AT_TOP: "pod_transaction_got_questions_field_at_top",
  ADD_CITY_MAPPER_WIDGET: "pod_discovery_add_citymapper_widget",
  SHOW_ACCREDITATIONS: "pod_discovery_show_accreditations",
  SHOW_MAP_ROUTES_UK_INTERNATIONAL: "pod_discovery_show_map_routes_uk_international",
  USE_SECONDARY_TOKEN_MAPBOX_FOR_DISTANCE_API:
    "pod_discovery_use_secondary_token_mapbox_for_distance_api",
  SHOW_PDP_APP_DOWNLOAD_BOTTOM_SHEET: "pod_discovery_show_pdp_app_download_bottom_sheet",
  REVIEWS_SECTION_V2: "pod_discovery_reviews_section_v2",
  SMART_FILTERS: "pod_discovery_smart_filters",
  SHOW_FLOOR_PLANS_SECTION: "pod_discovery_show_floor_plans_section",
  PERSONALIZED_SEARCH_SUGGESTIONS: "pod_discovery_personalized_search_suggestions",
  PROPERTY_PAGE_MEDIA_TABS: "pod_discovery_property_page_media_tabs",
  SMART_QUESTIONS: "pod_discovery_smart_questions",
  PROPERTY_DETAIL_TAGS_PRIORITY: "pod_discovery_property_detail_tags_priority",
};
export const MEET_THE_RESIDENT_COUNT = 3;
export const SEARCH_PAGE_CTA_VALUES = {
  OFF: "OFF",
  NO_CTA: "NO_CTA",
  VIEW_PROPERTY_CTA: "VIEW_PROPERTY_CTA",
};

// App download links
export const APP_DOWNLOAD_LINK = "https://amberstudent.sng.link/Djzr5/htgb?_smtype=3";

export const APP_DOWNLOAD_APP_STORE_LINK =
  "https://apps.apple.com/us/app/amber-book-student-housing/id6447250749";
export const APP_DOWNLOAD_PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.amberstudent";

// App download images
export const APP_DOWNLOAD_PLAY_STORE_IMG =
  "https://prod-static-assets.amberstudent.com/images/playStoreAppQR-hd.png";
export const APP_DOWNLOAD_APP_STORE_IMG =
  "https://prod-static-assets.amberstudent.com/images/appStoreAppQR-hd.png";

// App download Header Pages
export const APP_DOWNLOAD_OPTION_SHOWN_PAGES = [PAGE.HOME, PAGE.SEARCH, PAGE.INVENTORY];

export const SUPPORTED_LANG_CHINA = [
  {
    label: "English",
    value: "en",
  },
  {
    label: "中文",
    value: "zh",
  },
];

export const SUPPORTED_LANG = [
  {
    name: "English",
    label: "English",
    value: "en",
  },
  {
    name: "Spanish",
    label: "Español",
    value: "es",
  },
  {
    name: "French",
    label: "Français",
    value: "fr",
  },
  {
    name: "German",
    label: "Deutsch",
    value: "de",
  },
  {
    name: "Chinese",
    label: "中文",
    value: "zh",
  },
];

export const MWEB_HAMBURGER_MENU = "MWEB_HAMBURGER_MENU";
export const MWEB_APP_LAUNCH_PAGE = "MWEB_APP_LAUNCH_PAGE";
export const MWEB_HOME_PAGE = "MWEB_HOME_PAGE";
export const WEB_APP_LAUNCH_PAGE = "WEB_APP_LAUNCH_PAGE";

// export const APP_DOWNLOAD_URL = {
//   [PAGE.HOME]: `${BASE_IMG_URL}home-page-app-download.svg`,
//   [PAGE.SEARCH]: `${BASE_IMG_URL}search-page-app-download-qr.svg`,
//   [PAGE.INVENTORY]: `${BASE_IMG_URL}property-page-app-download-qr.svg`,
//   [MWEB_HAMBURGER_MENU]: "https://amberstudent.sng.link/Djzr5/9qwc?_smtype=3",
//   [MWEB_APP_LAUNCH_PAGE]: "https://amberstudent.sng.link/Djzr5/v8yz?_smtype=3",
//   [MWEB_HOME_PAGE]: "https://amberstudent.sng.link/Djzr5/4iw4?_smtype=3",
//   [WEB_APP_LAUNCH_PAGE]: "https://amberstudent.sng.link/Djzr5/3v0b?_smtype=3",
// };

// export const APP_DOWNLOAD_URL_NUDGE = {
//   [PAGE.HOME]: `${BASE_IMG_URL}nudge-home-page-app-download-qr.svg`,
//   [PAGE.SEARCH]: `${BASE_IMG_URL}nudge-search-page-app-download-qr.svg`,
//   [PAGE.INVENTORY]: `${BASE_IMG_URL}nudge-property-page-app-download-qr.svg`,
// };

export const APP_DOWNLOAD_URL_LINK = {
  [PAGE.HOME]: "https://amberstudent.sng.link/Djzr5/4iw4?_smtype=3",
  [PAGE.SEARCH]: "https://amberstudent.sng.link/Djzr5/xxd4?_smtype=3",
  [PAGE.INVENTORY]: "https://amberstudent.sng.link/Djzr5/8gj7?_smtype=3",
};

// URL's for Referral Page
export const REFERRAL_PAGE_STATIC_URL = "https://static-assets.amberstudent.com/images";
export const REFERRAL_PAGE_TELEGRAM_URL =
  "https://telegram.me/share/url?url=https%3A%2F%2Famberstudent.com%2Fplaces%2Fleads%2F%5Brefer-code%5D&text=Hey%20there!%20I%20recently%20signed%20up%20with%20amber%2C%20a%20top-rated%20student%20accommodation%20platform%20and%20found%20them%20pretty%20good!%20If%20you%27re%20looking%20for%20a%20great%20place%20to%20stay%2C%20use%20my%20referral%20link%20https%3A%2F%2Famberstudent.com%2Fplaces%2Fleads%2F%5Brefer-code%5D.%20You%27ll%20get%20to%20pick%20your%20perfect%20home%2C%20and%20I%27ll%20get%20%C2%A350%20cashback.%20Win-win!%0A%0AP.S.%20You%20can%20also%20refer%20your%20friends%20and%20earn%20%C2%A350%20cashback%20for%20each%20successful%20referral.%20Get%20your%20unique%20referral%20link%20here%20https%3A%2F%2Famberstudent.com%2Freferral-programme.";
export const REFERRAL_PAGE_WHATSAPP_URL =
  "https://api.whatsapp.com/send?text=Hey%20there!%20I%20recently%20signed%20up%20with%20amber%2C%20a%20top-rated%20student%20accommodation%20platform%20and%20found%20them%20pretty%20good!%20If%20you%27re%20looking%20for%20a%20great%20place%20to%20stay%2C%20use%20my%20referral%20link%20https%3A%2F%2Famberstudent.com%2Fplaces%2Fleads%2F%5Brefer-code%5D.%20You%27ll%20get%20to%20pick%20your%20perfect%20home%2C%20and%20I%27ll%20get%20%C2%A350%20cashback.%20Win-win!%0A%0AP.S.%20You%20can%20also%20refer%20your%20friends%20and%20earn%20%C2%A350%20cashback%20for%20each%20successful%20referral.%20Get%20your%20unique%20referral%20link%20here%20https%3A%2F%2Famberstudent.com%2Freferral-programme.";
export const REFERRAL_PAGE_MAILTO_URL =
  "mailto:?subject=Help%20me%20get%20%C2%A350%20cashback%20on%20amber&body=Hey%20there!%20I%20recently%20signed%20up%20with%20amber%2C%20a%20top-rated%20student%20accommodation%20platform%20and%20found%20them%20pretty%20good!%20If%20you%27re%20looking%20for%20a%20great%20place%20to%20stay%2C%20use%20my%20referral%20link%20https%3A%2F%2Famberstudent.com%2Fplaces%2Fleads%2F%5Brefer-code%5D.%20You%27ll%20get%20to%20pick%20your%20perfect%20home%2C%20and%20I%27ll%20get%20%C2%A350%20cashback.%20Win-win!%0A%0AP.S.%20You%20can%20also%20refer%20your%20friends%20and%20earn%20%C2%A350%20cashback%20for%20each%20successful%20referral.%20Get%20your%20unique%20referral%20link%20here%20https%3A%2F%2Famberstudent.com%2Freferral-programme.";

// URL's for Ambassador Page
export const AMBASSADOR_PAGE_STATIC_URL = "https://static-assets.amberstudent.com/images";

// URL's for Scholarship Page
export const SCHOLARSHIP_PAGE_STATIC_URL = "https://static-assets.amberstudent.com/images";

export * from "./scholarshipConstants";

export const CAMPAIGN_LIST_FOR_REMOVE_BOOKING_CTA = ["long_form"];
export const APP_BANNER_HEIGHT = 73;
export const APP_REVIEW = "4.5/5";
export const APP_BANNER_TEXT = "cashback on the app!";
export const APP_DOWNLOADS = "180K+ Downloads";
export const MIN_DISTANCE_VALUE = 0;
export const MAX_DISTANCE_VALUE = 20;

export const BOOK_EARLY_REGIONS = [
  "Aberdeen",
  "Belfast",
  "Birmingham",
  "Bradford",
  "Canterbury",
  "Cardiff",
  "Edinburgh",
  "Leeds",
  "Liverpool",
  "London",
  "Manchester",
  "Newcastle upon Tyne",
  "Nottingham",
  "Oxford",
  "Preston",
  "Swansea",
];

// export const AMBER_LOGO_URL = config.global.isChinaApp
//   ? "https://imgix.amberstudent.cn/images/china_logo_amber.svg?auto=format&q=10"
//   : "https://prod-static-assets.amberstudent.com/images/amber-hd.svg?auto=format";

// export const AMBER_LOGO_URL_DARK = config.global.isChinaApp
//   ? "https://imgix.amberstudent.cn/images/logo/amber-china-logo-dark.svg?auto=format&q=10"
//   : "https://prod-static-assets.amberstudent.com/images/logo/amber-logo-dark.svg?auto=format";

// export const AMBER_LOGO_URL_LIGHT = config.global.isChinaApp
//   ? "https://imgix.amberstudent.cn/images/logo/amber-china-logo-light.svg?auto=format&q=10"
//   : "https://prod-static-assets.amberstudent.com/images/logo/amber-logo-light.svg?auto=format";

export const AMBER_GIF_URL =
  "https://s3.ap-southeast-1.amazonaws.com/static-assets.amberstudent.com/images/amberGIfLoop1.gif";

export const JSON_SCHEMA_REMOVAL_TEST_PAGES_SLUG = [
  "barcelona-2011053744668",
  "surry-hills-1811239423025",
  "university-of-the-west-of-england-1811049440130",
  "soho-1811029029457",
  "30-kerr-parade-auburn-sydney-2309264052491",
  "academy-apartments-manchester-2105271158165",
  "campus-walk-apartments-2206158940077",
  "abbey-house-coventry-1804039830535",
];

export const MICRO_DATA_SEO_TEST_PAGES_SLUG = [
  ...JSON_SCHEMA_REMOVAL_TEST_PAGES_SLUG,
  "watford-1905111988293",
  "st-lucia-1811025596204",
  "york-1811025154987",
  "st-albans-1811236175998",
  "fitzroy-wenlock-courts-luton-1807151895941",
  "pittodrie-street-aberdeen-1901147089020",
  "london-house-stoke-on-trent-2301178492641",
  "carric-hostel-melbourne-2301031385397",
];

export const MAP_KEY = "AIzaSyAHJ5nH6Gyx2wWTh15V3h0ro8aO24KXNAA";
export const STATIC_MAP_MARKER_ICON = `${config.IMAGE_STATIC_URL}/images/map/dot-icon.ico`;
export const DEFAULT_CENTER = { lat: 37.4237129802915, lng: -122.0830150197085 };

export const EVENTS = {
  SEARCH_MAP_HIGHLIGHT: "SEARCH_MAP_HIGHLIGHT",
  SEARCH_MAP_HIGHLIGHT_REMOVE: "SEARCH_MAP_HIGHLIGHT_REMOVE",
  HOVERED_MAP_PIN_INVENTORY_HIGHLIGHT: "HOVERED_MAP_PIN_INVENTORY_HIGHLIGHT", // ---> replaced SEARCH_DETAILS_VIEW_SHOW: "SEARCH_DETAILS_VIEW_SHOW",
};

export const FORM_KEYS = {
  BOOK_FORM: "BOOK_FORM",
  PAYMENT_BOOKING_DETAILS: "PAYMENT_FORM_DETAILS",
  PAYMENT_DETAILS: "PAYMENT_DETAILS",
  PAYMENT_ACCOMODATION_DETAILS: "PAYMENT_ACCOMODATION_DETAILS",
  PAYMENT_INVENTORY_DETAILS: "PAYMENT_INVENTORY_DETAILS",
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  SHOW_NPS_CARD: "SHOW_NPS_CARD",
  SHOW_NPS_CARD_FINAL_SCREEN: "SHOW_NPS_CARD_FINAL_SCREEN",
  PAYMENT_DECLINE: "PAYMENT_DECLINE",
  PAYMENT_CARD_INFO: "PAYMENT_CARD_INFO",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  LATEST_PAYMENT_DATA: "LATEST_PAYMENT_DATA",
};

export const HAPPY_FLOW_TENANCY_CTAS = {
  BOOK: "Book",
  APPLY_NOW: "Apply Now",
  CONTINUE_BOOKING: "Continue to Book",
  CONTINUE_APPLY: "Continue to Apply",
  CONTINUE_PAYMENT: "Continue to Pay",
  VIEW_BOOKINGS: "View Bookings",
  ENQUIRE_NOW: !config.IS_WHITELABEL_APP ? "Enquire Now" : "Enquire",
  ENQUIRED: "Enquired",
  JOIN_WAITLIST: "Join Waitlist",
  WAITLISTED: "Waitlisted",
  CONTACT_US: "Contact Us",
  CONTACTED: "Contacted",
};

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const shareReferCodeChannel = [
  {
    label: "whatsapp",
    icon: "https://prod-static-assets.amberstudent.com/images/whatsapp-logo.svg",
    redirect: `https://api.whatsapp.com/send?text=Hey%2C%20I%20just%20referred%20you%20to%20amberstudent.com%20for%20your%20student%20housing%20search%21%20They%20seem%20pretty%20promising%20for%20helping%20students%20within%20your%20budget.%0ACheck%20them%20out%20-%20https%3A%2F%2Famberstudent.com%2Fl%2F[refer-code]`,
    iconAlt: "whatsapp-icon-image",
    tooltipText: "Share on WhatsApp",
  },
  {
    label: "telegram",
    icon: "https://prod-static-assets.amberstudent.com/images/telegram-logo.svg",
    redirect: `https://telegram.me/share/url?url=https%3A%2F%2Famberstudent.com%2Fl%2F[refer-code]&text=Hey%2C%20I%20just%20referred%20you%20to%20amberstudent.com%20for%20your%20student%20housing%20search%21%20They%20seem%20pretty%20promising%20for%20helping%20students%20within%20your%20budget.%0ACheck%20them%20out%20-%20https%3A%2F%2Famberstudent.com%2Fl%2F[refer-code]`,
    iconAlt: "telegram-icon-image",
    tooltipText: "Share on Telegram",
  },
  {
    label: "email",
    icon: "https://prod-static-assets.amberstudent.com/images/email-logo.svg",
    redirect: `mailto:?subject=Check%20out%20amberstudent.com%20for%20your%20student%20housing%20search&body=Hey%2C%20I%20just%20referred%20you%20to%20amberstudent.com%20for%20your%20student%20housing%20search%21%20They%20seem%20pretty%20promising%20for%20helping%20students%20within%20your%20budget.%0ACheck%20them%20out%20-%20https%3A%2F%2Famberstudent.com%2Fl%2F[refer-code]`,
    iconAlt: "email-icon-image",
    tooltipText: "Share via Email",
  },
];

export const BOOKING_STATUS = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const NON_WHITELABEL_SUBDOMAINS = [
  "www",
  "localhost",
  "dev-amber",
  "staging-amber",
  "amberstudent",
  "staging-hk",
  "dev-hk",
  "hk",
];

export const WHITELABEL_SUBDOMAIN_VALUE = "whitelabel";

/**
 * Checks if a subdomain is a whitelabel demo subdomain.
 * Matches "whitelabel" and PR preview variants like "pr-5842-whitelabel".
 */
export const isDemoWhitelabelSubdomain = (subdomain: string): boolean =>
  subdomain === WHITELABEL_SUBDOMAIN_VALUE || /^pr-\d+-whitelabel$/.test(subdomain);

export const AMBER_USER_WEBSITE_CONFIGURABLE_COMPONENTS = {
  home_page_top_banner: "home_page_top_banner",
  search_page_top_banner: "search_page_top_banner",
  home_page_hero_section: "home_page_hero_section",
};

export const GUMLET_BASE_URL = "https://videos.amberstudent.com/";

export const META_EVENT_CONSTANTS = {
  SEARCH_VIEWED: "Search_viewed",
  PROPERTY_VIEWED: "ViewContent",
  PROPERTY_WISHLISTED: "AddToWishlist",
  PROPERTY_ENQUIRED: "Lead",
  BOOK_FORM_SUBMITTED: "conversion_book_form",
  PAYMENT_COMPLETED: "conversion_payment",
};

export const DELETE_ACCOUNT_SCRREN_CONSTANTS = {
  DELETE_ACCOUNT_HEADING: "You’re about to delete your account",
  DELETE_ACCOUNT_SUBHEADING:
    "You will permanently lose access to all data associated with it (including your profile, photos, and reviews). Once the account is deleted, this information cannot be recovered.",
  DELETE_ACCOUNT_PRIMARY_BUTTON_TITLE: "Delete Account",
  DELETE_ACCOUNT_SECONDARY_BUTTON_TITLE: "Back to settings",
  DELETE_ACCOUNT_REASONS: [
    { reason: "I don’t want to use amber anymore" },
    { reason: "I’m worried about my privacy" },
    { reason: "I’m using different account" },
    { reason: "The app is not working properly" },
    { reason: "Other" },
  ],
};

export const SORTING_ALGO_V2_REGION_IDS_50 = [34, 75, 43, 70, 38, 67, 18, 19, 55, 37];
export const offersAllowedAgentIds: (number | null)[] = [
  11795, // "kelvin.lee@amberstudent.com",
  7249, // "trang.kim@amberstudent.com",
  12785, // "panithan.i@amberstudent.com",
  11794, // "kiaraa.s@amberstudent.com",
  6616, // "damien.pang@amberstudent.com",
];

export const AMENITY_TYPE_PRIORITY = [
  "shared_community_and_utilities",
  "fitness_and_recreation",
  "security",
  "property_services",
  "parking",
  "outdoor_features",
  "common_amenities",
];
